import { render, staticRenderFns } from "./AddAliasModal.vue?vue&type=template&id=2784cceb&"
import script from "./AddAliasModal.vue?vue&type=script&lang=js&"
export * from "./AddAliasModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2784cceb')) {
      api.createRecord('2784cceb', component.options)
    } else {
      api.reload('2784cceb', component.options)
    }
    module.hot.accept("./AddAliasModal.vue?vue&type=template&id=2784cceb&", function () {
      api.rerender('2784cceb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/AddAliasModal.vue"
export default component.exports